import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { IMasterListItemAction } from '../../../entity-master/components/master-list-item/master-list-item.interface';
import { PayPalTransactionItem } from '../../../payments-data/payments-data.data';
import { NavigationService } from '../../../navigation/navigation.service';
import {
  CLIENTS_MASTER_ROUTE,
  ESTIMATES_MASTER_ROUTE,
  INVOICES_MASTER_ROUTE,
} from '../../../main/main.data';
import { I2gDialogService } from 'i2g-ng-ui';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';

@Component({
  selector: 'app-paypal-transactions',
  templateUrl: './paypal-transactions.component.html',
  styleUrls: ['./paypal-transactions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayPalTransactionsComponent implements OnInit {
  @Input()
  transactions: List<PayPalTransactionItem> = List<PayPalTransactionItem>([]);
  @Input() parentContainer: ElementRef;

  menuActions: {
    [DocumentTypesEnum: string]: List<List<IMasterListItemAction>>;
  };

  constructor(
    private _navigationService: NavigationService,
    private _dialogService: I2gDialogService
  ) {}

  ngOnInit() {
    this.menuActions = this._buildMenuActions();
  }

  handleMenuAction(
    id: 'view_client' | 'view_invoice' | 'view_estimate',
    transaction: PayPalTransactionItem
  ) {
    this._dialogService.closeDialog();

    switch (id) {
      case 'view_client':
        return this._navigationService.goTo([
          CLIENTS_MASTER_ROUTE,
          transaction.document.client_id,
        ]);
      case 'view_invoice':
        return this._navigationService.goTo([
          INVOICES_MASTER_ROUTE,
          transaction.document.document_id,
        ]);
      case 'view_estimate':
        return this._navigationService.goTo([
          ESTIMATES_MASTER_ROUTE,
          transaction.document.document_id,
        ]);
      default:
        break;
    }
  }

  _buildMenuActions(): {
    [DocumentTypesEnum: string]: List<List<IMasterListItemAction>>;
  } {
    const defaultItems = [
      {
        id: 'view_client',
        label: 'PAYMENTS.PAYPAL.TRANSACTION_HISTORY.ACTIONS.VIEW_CLIENT',
      },
    ];

    return {
      [DocumentTypesEnum.invoice]: List([
        List([
          ...defaultItems,
          {
            id: 'view_invoice',
            label: 'PAYMENTS.PAYPAL.TRANSACTION_HISTORY.ACTIONS.VIEW_INVOICE',
          },
        ]),
      ]),
      [DocumentTypesEnum.estimate]: List([
        List([
          ...defaultItems,
          {
            id: 'view_estimate',
            label: 'PAYMENTS.PAYPAL.TRANSACTION_HISTORY.ACTIONS.VIEW_ESTIMATE',
          },
        ]),
      ]),
    };
  }
}
